import * as Yup from 'yup'

export const freeShippingIv = {
    shipping_service_name: "",
    shipping_type: "",
    shipping_name: "",
    description_for_customer: "",
    minimum_order_subtotal: "",
    estimated_transit_time_from: "",
    estimated_transit_time_to: "",
    order_preparation_time: "",
    custom_time_frame_from: "",
    custom_time_frame_to: "",
    orders_received_past_this_time_on_the_next_day: "",
    days_when_you_pack_orders: [],
    shipping_region: "All",
    zone: "",
    status: 1
}

export const freeShippingParams = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        status: values.status ?? 1
    }

    if (!Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
        data.days_when_you_pack_orders_ = "1"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
        data.days_when_you_pack_orders_ = "2"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
        data.days_when_you_pack_orders_ = "3"
    } else {
        data.days_when_you_pack_orders_ = "4"
    }

    return data
}

export const freeShippinVS = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }
    if (!values.description_for_customer) {
        errors.description_for_customer = "This field is required"
    }
    if (!values.estimated_transit_time_from) {
        errors.estimated_transit_time_from = "This field is required"
    } else if (parseInt(values.estimated_transit_time_from) < 1) {
        errors.estimated_transit_time_from = "Invalid"
    }

    if (parseInt(values.custom_time_frame_from) < 1) {
        errors.custom_time_frame_from = "Invalid"
    }

    if (values.custom_time_frame_from && values.custom_time_frame_to &&
        parseInt(values.custom_time_frame_from) >= parseInt(values.custom_time_frame_to)) {
        errors.custom_time_frame_to = "invalid"
    }

    if (!values.estimated_transit_time_to) {
        errors.estimated_transit_time_to = "This field is required"
    } else if (parseInt(values.estimated_transit_time_to) < 1) {
        errors.estimated_transit_time_to = "Invalid"
    }

    if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
        parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
        errors.estimated_transit_time_to = "invalid"
    }

    if (!values.minimum_order_subtotal) {
        errors.minimum_order_subtotal = "This field is required"
    }

    if (!values.order_preparation_time) {
        errors.order_preparation_time = "This field is required"
    }
    if (!values.orders_received_past_this_time_on_the_next_day) {
        errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    }
    if (!values.shipping_region || values.shipping_region === " ") {
        errors.shipping_region = "This field is required"
    }
    if (!values.days_when_you_pack_orders) {
        errors.days_when_you_pack_orders = "This field is required"
    }
    return errors
}

export const flatRateShippingIv = {
    shipping_service_name: "",
    shipping_type: "",
    shipping_name: "",
    description_for_customer: "",
    minimum_order_subtotal: "",
    estimated_transit_time_from: "",
    estimated_transit_time_to: "",
    order_preparation_time: "",
    custom_time_frame_from: "",
    custom_time_frame_to: "",
    orders_received_past_this_time_on_the_next_day: "",
    days_when_you_pack_orders: [],
    shipping_region: "All",
    zone: "",
    amount_type: "",
    amount: "",
    status: 1
}

export const flatRateShippingParams = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        status: values.status ?? 1,
        amount_type: values.amount_type ?? "flat",
        amount: values.amount ?? "0"
    }

    if (!Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
        data.days_when_you_pack_orders_ = "1"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
        data.days_when_you_pack_orders_ = "2"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
        data.days_when_you_pack_orders_ = "3"
    } else {
        data.days_when_you_pack_orders_ = "4"
    }


    let a = {}
    if (values.shippingrates) {
        a = values.shippingrates[0] || {}
    }
    if (a.amount_type) {
        data.amount_type = a.amount_type
        data.amount = a.amount
    }

    return data
}
export const flatRateShippingVS = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }
    if (!values.amount_type) {
        errors.amount_type = "This field is required"
    }
    if (!values.amount) {
        errors.amount = "This field is required"
    }
    if (!values.description_for_customer) {
        errors.description_for_customer = "This field is required"
    }

    if (parseInt(values.custom_time_frame_from) < 1) {
        errors.custom_time_frame_from = "Invalid"
    }

    if (values.custom_time_frame_from && values.custom_time_frame_to &&
        parseInt(values.custom_time_frame_from) >= parseInt(values.custom_time_frame_to)) {
        errors.custom_time_frame_to = "invalid"
    }

    if (!values.estimated_transit_time_from) {
        errors.estimated_transit_time_from = "This field is required"
    } else if (parseInt(values.estimated_transit_time_from) < 1) {
        errors.estimated_transit_time_from = "Invalid"
    }

    if (!values.estimated_transit_time_to) {
        errors.estimated_transit_time_to = "This field is required"
    } else if (parseInt(values.estimated_transit_time_to) < 1) {
        errors.estimated_transit_time_to = "Invalid"
    }

    if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
        parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
        errors.estimated_transit_time_to = "invalid"
    }

    if (!values.minimum_order_subtotal) {
        errors.minimum_order_subtotal = "This field is required"
    }

    if (!values.order_preparation_time) {
        errors.order_preparation_time = "This field is required"
    }
    if (!values.orders_received_past_this_time_on_the_next_day) {
        errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    }
    if (!values.shipping_region || values.shipping_region === " ") {
        errors.shipping_region = "This field is required"
    }
    if (!values.days_when_you_pack_orders) {
        errors.days_when_you_pack_orders = "This field is required"
    }

    return errors
}


export const customRateShippingIv = {
    shipping_service_name: "",
    shipping_type: "",
    shipping_name: "",
    description_for_customer: "",
    minimum_order_subtotal: "",
    estimated_transit_time_from: "",
    estimated_transit_time_to: "",
    order_preparation_time: "",
    custom_time_frame_from: "",
    custom_time_frame_to: "",
    orders_received_past_this_time_on_the_next_day: "",
    days_when_you_pack_orders: [],
    shipping_region: "All",
    zone: "",
    range_from: [],
    range_to: [],
    rate_per_item: [],
    rate_percent_charge: [],
    rate_per_lbs: [],
    table_based_on: "",
    rate_based_on: "",
    status: 1,
    shippingrates: []

}
export const customRateShippingParams = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        range_from: values.range_from || [],
        range_to: values.range_to || [],
        rate_per_item: values.rate_per_item || [],
        rate_per_order: values.rate_per_order || [],
        rate_percent_charge: values.rate_percent_charge || [],
        rate_per_lbs: values.rate_per_lbs || [],
        table_based_on: values.table_based_on || "",
        rate_based_on: values.rate_based_on || "",
        status: values.status ?? 1,
        shippingrates: values.shippingrates || []
    }

    if (!Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
        data.days_when_you_pack_orders_ = "1"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
        data.days_when_you_pack_orders_ = "2"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
        data.days_when_you_pack_orders_ = "3"
    } else {
        data.days_when_you_pack_orders_ = "4"
    }


    // range_from: [],
    // range_to: [],
    // rate_per_item: [],
    // rate_percent_charge: [],
    // rate_per_lbs: [],

    if (values.shippingrates) {
        data.range_from = []
        data.range_to = []
        data.rate_per_order = []
        data.rate_per_item = []
        data.rate_percent_charge = []
        data.rate_per_lbs = []
        values.shippingrates.forEach(e => {
            data.range_from.push(e.range_from || 0)
            data.range_to.push(e.range_to || 0)
            data.rate_per_order.push(e.rate_per_order || 0)
            if (data.rate_based_on === "full") {
                data.rate_per_item.push(e.rate_per_item || 0)
                data.rate_percent_charge.push(e.rate_percent_charge || 0)
                data.rate_per_lbs.push(e.rate_per_lbs || 0)
            }
        })
    }
    delete data.shippingrates

    return data
}

export const customRateShippingParams_ = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        range_from: values.range_from || [],
        range_to: values.range_to || [],
        rate_per_item: values.rate_per_item || [],
        rate_per_order: values.rate_per_order || [],
        rate_percent_charge: values.rate_percent_charge || [],
        rate_per_lbs: values.rate_per_lbs || [],
        table_based_on: values.table_based_on || "",
        rate_based_on: values.rate_based_on || "",
        status: values.status ?? 1,
        shippingrates: values.shippingrates || []
    }

    if (values.days_when_you_pack_orders && !Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (!values.days_when_you_pack_orders_) {
        if (Array.isArray(values.days_when_you_pack_orders)) {
            data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
        }
        if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
            data.days_when_you_pack_orders_ = "1"
        } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
            data.days_when_you_pack_orders_ = "2"
        } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
            data.days_when_you_pack_orders_ = "3"
        } else {
            data.days_when_you_pack_orders_ = "4"
        }
    }


    // range_from: [],
    // range_to: [],
    // rate_per_item: [],
    // rate_percent_charge: [],
    // rate_per_lbs: [],

    // if (values.shippingrates) {
    //     values.shippingrates.forEach(e => {
    //         data.range_from.push(e.range_from)
    //         data.range_to.push(e.range_to)
    //         data.rate_per_item.push(e.rate_per_item)
    //         data.rate_percent_charge.push(e.rate_percent_charge)
    //         data.rate_per_lbs.push(e.rate_per_lbs)
    //     })

    // }
    // data.shippingrates

    return data
}

export const customRateShippingVs = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }

    if (!values.description_for_customer) {
        errors.description_for_customer = "This field is required"
    }
    if (!values.estimated_transit_time_from) {
        errors.estimated_transit_time_from = "This field is required"
    } else if (parseInt(values.estimated_transit_time_from) < 1) {
        errors.estimated_transit_time_from = "Invalid"
    }
    if (parseInt(values.custom_time_frame_from) < 1) {
        errors.custom_time_frame_from = "Invalid"
    }

    if (values.custom_time_frame_from && values.custom_time_frame_to &&
        parseInt(values.custom_time_frame_from) >= parseInt(values.custom_time_frame_to)) {
        errors.custom_time_frame_to = "invalid"
    }
    if (!values.estimated_transit_time_to) {
        errors.estimated_transit_time_to = "This field is required"
    } else if (parseInt(values.estimated_transit_time_to) < 1) {
        errors.estimated_transit_time_to = "Invalid"
    }

    if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
        parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
        errors.estimated_transit_time_to = "invalid"
    }

    if (!values.minimum_order_subtotal) {
        errors.minimum_order_subtotal = "This field is required"
    }

    if (!values.order_preparation_time) {
        errors.order_preparation_time = "This field is required"
    }
    if (!values.orders_received_past_this_time_on_the_next_day) {
        errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    }
    if (!values.shipping_region || values.shipping_region === " ") {
        errors.shipping_region = "This field is required"
    }
    if (!values.days_when_you_pack_orders) {
        errors.days_when_you_pack_orders = "This field is required"
    }

    return errors
}

export const conditionalShippingIv = {
    shipping_service_name: "",
    shipping_name: "",
    description_for_customer: "",
    minimum_order_subtotal: "",
    estimated_transit_time_from: "",
    estimated_transit_time_to: "",
    order_preparation_time: "",
    custom_time_frame_from: "",
    custom_time_frame_to: "",
    days_when_you_pack_orders: [],
    orders_received_past_this_time_on_the_next_day: "",
    shipping_region: "All",
    zone: "",
    range_from: [],
    range_to: [],
    amount: [],
    rate_per_item: [],
    rate_percent_charge: [],
    rate_per_lbs: [],
    up_range_from: [],
    up_range_to: [],
    up_rate_per_order: [],
    up_rate_per_item: [],
    up_rate_percent_charge: [],
    up_rate_per_lbs: [],
    table_based_on: "",
    rate_based_on: "",
    status: 1
}

export const conditionalShippingParams = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        range_from: values.range_from || [],
        range_to: values.range_to || [],
        amount: values.amount || [],
        rate_per_item: values.rate_per_item || [],
        rate_percent_charge: values.rate_percent_charge || [],
        rate_per_lbs: values.up_rate_per_lbs || [],
        // up_range_from: values.up_range_from || [],
        // up_range_to: values.up_range_to || [],
        // up_rate_per_order: values.up_rate_per_order || [],
        // up_rate_per_item: values.up_rate_per_item || [],
        // up_rate_percent_charge: values.up_rate_percent_charge || [],
        // up_rate_per_lbs: values.up_rate_per_lbs || [],
        table_based_on: values.table_based_on || "",
        rate_based_on: values.rate_based_on || "",
        status: values.status ?? 1,
    }

    if (!Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
        data.days_when_you_pack_orders_ = "1"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
        data.days_when_you_pack_orders_ = "2"
    } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
        data.days_when_you_pack_orders_ = "3"
    } else {
        data.days_when_you_pack_orders_ = "4"
    }

    if (values.shippingrates) {
        data.range_from = []
        data.range_to = []
        data.rate_per_order = []
        data.rate_per_item = []
        data.rate_percent_charge = []
        data.rate_per_lbs = []
        values.shippingrates.forEach(e => {
            data.range_from.push(e.range_from || 0)
            data.range_to.push(e.range_to || 0)
            data.rate_per_order.push(e.rate_per_order || 0)
            if (data.rate_based_on === "full") {
                data.rate_per_item.push(e.rate_per_item || 0)
                data.rate_percent_charge.push(e.rate_percent_charge || 0)
                data.rate_per_lbs.push(e.rate_per_lbs || 0)
            }
        })
    }
    delete data.shippingrates

    return data
}

export const conditionalShippingParams_ = (values) => {
    const data = {
        shipping_service_name: values.shipping_service_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || [],
        shipping_region: values.shipping_region || " ",
        zone: values.zone || "",
        range_from: values.range_from || [],
        range_to: values.range_to || [],
        amount: values.amount || [],
        rate_per_item: values.rate_per_item || [],
        rate_percent_charge: values.rate_percent_charge || [],
        rate_per_lbs: values.up_rate_per_lbs || [],
        // up_range_from: values.up_range_from || [],
        // up_range_to: values.up_range_to || [],
        // up_rate_per_order: values.up_rate_per_order || [],
        // up_rate_per_item: values.up_rate_per_item || [],
        // up_rate_percent_charge: values.up_rate_percent_charge || [],
        // up_rate_per_lbs: values.up_rate_per_lbs || [],
        table_based_on: values.table_based_on || "",
        rate_based_on: values.rate_based_on || "",
        shippingrates: values.shippingrates || [],
        status: values.status ?? 1,
    }

    if (values.days_when_you_pack_orders && !Array.isArray(values.days_when_you_pack_orders)) {
        data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
    }

    if (values.id) {
        data.id = values.id
    }

    if (!values.days_when_you_pack_orders_) {
        if (Array.isArray(values.days_when_you_pack_orders)) {
            data.days_when_you_pack_orders = values.days_when_you_pack_orders.split(",")
        }
        if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday") {
            data.days_when_you_pack_orders_ = "1"
        } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday") {
            data.days_when_you_pack_orders_ = "2"
        } else if (values.days_when_you_pack_orders === "monday,tuesday,wednesday,thursday,friday,saturday,sunday") {
            data.days_when_you_pack_orders_ = "3"
        } else {
            data.days_when_you_pack_orders_ = "4"
        }
    }

    // if (values.shippingrates) {
    //     values.shippingrates.forEach(e => {
    //         data.range_from.push(e.range_from)
    //         data.range_to.push(e.range_to)
    //         data.rate_per_item.push(e.rate_per_item)
    //         data.rate_percent_charge.push(e.rate_percent_charge)
    //         data.rate_per_lbs.push(e.rate_per_lbs)
    //     })

    // }


    return data
}
export const conditionalShippingVs = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }

    if (!values.description_for_customer) {
        errors.description_for_customer = "This field is required"
    }
    if (!values.estimated_transit_time_from) {
        errors.estimated_transit_time_from = "This field is required"
    } else if (parseInt(values.estimated_transit_time_from) < 1) {
        errors.estimated_transit_time_from = "Invalid"
    }

    if (parseInt(values.custom_time_frame_from) < 1) {
        errors.custom_time_frame_from = "Invalid"
    }

    if (values.custom_time_frame_from && values.custom_time_frame_to &&
        parseInt(values.custom_time_frame_from) >= parseInt(values.custom_time_frame_to)) {
        errors.custom_time_frame_to = "invalid"
    }
    if (!values.estimated_transit_time_to) {
        errors.estimated_transit_time_to = "This field is required"
    } else if (parseInt(values.estimated_transit_time_to) < 1) {
        errors.estimated_transit_time_to = "Invalid"
    }

    if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
        parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
        errors.estimated_transit_time_to = "invalid"
    }


    if (parseInt(values.custom_time_frame_from) < 1) {
        errors.custom_time_frame_from = "Invalid"
    }

    if (values.custom_time_frame_from && values.custom_time_frame_to &&
        parseInt(values.custom_time_frame_from) >= parseInt(values.custom_time_frame_to)) {
        errors.custom_time_frame_to = "invalid"
    }

    if (!values.minimum_order_subtotal) {
        errors.minimum_order_subtotal = "This field is required"
    }

    if (!values.order_preparation_time) {
        errors.order_preparation_time = "This field is required"
    }
    if (!values.orders_received_past_this_time_on_the_next_day) {
        errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    }
    if (!values.shipping_region || values.shipping_region === " ") {
        errors.shipping_region = "This field is required"
    }
    if (!values.days_when_you_pack_orders) {
        errors.days_when_you_pack_orders = "This field is required"
    }
    // if (!values.range_from || !Array.isArray(values.range_from) || values.range_from.length === 0) {
    //     errors.range_from = "This field is required"
    // }

    // if (!values.range_to || !Array.isArray(values.range_to) || values.range_to.length === 0) {
    //     errors.range_to = "This field is required"
    // }


    return errors
}

export const deleteExtra = (params) => {
    delete params.days_when_you_pack_orders_

    delete params.monday
    delete params.tuesday
    delete params.wednesday
    delete params.thursday
    delete params.friday
    delete params.saturday
    delete params.sunday
    return params
}

export const automaticShippingVS = Yup.object({

})